// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1S2QWR-np6_1B_ONqb0_2y","link":"_6WG5rwesACftVFjXBUuDU b-overlay"};